<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>

            <header-table titlePage="LISTA DE PERMISSÕES" :data="searchedData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="4" :totalPDF="total" titleReport="Relátorio de Permissões">
                <md-button v-if="permissoes.permissaoCreate" class="md-button md-success md-just-icon md-round" :to="{ name: 'permissaoCreate' }">
                    <i class="fas fa-plus"></i>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-35 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Nome, Descrição ou Link" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-15 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                            <div class="md-layout-item md-size-40 md-xsmall-size-100">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise no resultado da busca aqui." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>                  

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">                        
                        <md-table-cell class="uppercase" md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="NOME" style="width: 20%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="DESCRIÇÃO" style="width: 25%">{{ item.descricao }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="GRUPO" style="width: 15%">{{ item.grupo }}</md-table-cell>
                        <md-table-cell md-label="LINK" style="width: 15%" md-sort-by="usuario">{{ item.link }}</md-table-cell>
                        <md-table-cell md-label="DESENVOLVEDOR" style="width: 15%" md-sort-by="usuario">
                            {{ item.desenvolvedor == true ? 'SIM' : 'NÃO' }}</md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item @click="editar(item.id)">
                                        EDITAR <md-icon class="text-warning">edit</md-icon>
                                    </md-menu-item>
                                    <md-menu-item @click="apagar(item.id, item.nome)">
                                        DELETAR<md-icon class="text-danger">delete_forever</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import preLoader from '@/config/mixins/preLoader';
import {
    Pagination
} from "@/components";

export default {
    name: 'ReadUsuario',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    mixins: [TableSearch, Notify, preLoader],

    data() {
        return {
            usuario: {
                situacao_id: 1
            },
            loader: false,
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'permissoes/',
            columnsPDF: [15, 75, 30, 60],
            headRowsPDF: ['ID', 'NOME', 'GRUPO', 'LINK'],
            fildsTXT: ['id', 'nome', 'grupo', 'link'],
            bodyRowsPDF: ['id', 'nome', 'grupo', 'link'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "NOME",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "GRUPO",
                    field: "grupo",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "LINK",
                    field: "link",
                }
            ],          
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                busca: ''
            }
        };
    },

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            let loader = this.openLoader('dots');
            this.buscar.situacao_id = this.usuario.situacao_id
            pagi = pagi || this.$urlAPI + 'permissoes/buscar'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.descricao, item.link]).includes(this.toLower(term)))
            }
            return items
        },

        editar(id) {
            this.$router.push({
                name: 'permissaoUpdate',
                params: {
                    id: id
                }
            })
        },

        apagar(id, nome) {
            this.deletar = true
            this.handleDelete(id, nome)
        }
    },

};
</script>
